<template>
<v-app dir="ltr">
  <!--    <Loader v-if="!$store.getters['global/isLoaded']"/>-->
  <!--    <router-view v-else/>-->
  <router-view />
       <set-address-profile v-if="shouldShowAddressPopup"
      v-model="showAddressPopup" 
      @success="onAddressSuccess" 
    />

</v-app>

</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";
@import "assets/css/custom.css";
@import "assets/css/btnStyle.css";

// Main demo style scss
@import "assets/css/style.vue.rtl";

// Check documentation for RTL cssmixins.js
// Update HTML with RTL attribute at public/index.html
/*@import "assets/css/style.vue.rtl";*/
.v-application {
  background: transparent !important;
  
  .v-application--wrap {
    background: transparent !important;
    min-height: 100vh;
  }
}

</style>

<script>
import { rbAxios, QrAxios } from "@/main";
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import Loader from "@/view/content/PreLoader.vue";
import "bootstrap";
import setAddressProfile from "./core/plugins/TitleRibbon/setAddressProfile.vue";

export default {
  name: "MetronicVue",
  components: {
    Loader,setAddressProfile
  },
  computed: {
    shouldShowAddressPopup() {
      try {
        const userInfo = localStorage.getItem("userInfo");
        if (!userInfo) return false; 
        
        const parsedUser = JSON.parse(userInfo);
        return parsedUser && Number(parsedUser.id) !== 75;
      } catch (e) {
        return false;
      }
    }
  },
    mounted() {
    QrAxios.defaults.headers["Authorization"] = `Bearer ${localStorage.getItem(
      "id_token",
    )}`;
    rbAxios.defaults.headers["Authorization"] =
      localStorage.getItem("id_token");
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
    // this.requestApiGetCore('abilitiesType').then(response => {
    //   this.$ability.update([
    //     { subject: 'all', actions: response.data}
    //   ])
    // })
  this.$root.$on("open-address-popup", () => {
      this.showAddressPopup = true;
    });

  },
    data(){
    return{
      showAddressPopup: false,
    }
  },
  methods:{
     onAddressSuccess() {
      console.log("آدرس با موفقیت ثبت شد");
    }
  },
  beforeDestroy() {
    this.$root.$off("open-address-popup");
  },
};
</script>
